// extracted by mini-css-extract-plugin
module.exports = {"root":"g8_yuoFr","description":"RwlHycot","styledButtonLink":"NxpLWJmK"};